import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-alarm",
  "use": "icon-alarm-usage",
  "viewBox": "0 0 64.6 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64.6 64\" id=\"icon-alarm\">\r\n<path d=\"M63.2,52.7L37.9,8.8c-3.1-5.4-8.2-5.4-11.3,0L1.3,52.7C-1.8,58,0.8,62.4,7,62.4h50.7C63.8,62.4,66.3,58,63.2,52.7z\r\n\t M28.9,19.2c1-1,2.2-1.6,3.7-1.6c1.5,0,2.7,0.5,3.7,1.5c1,1,1.4,2.3,1.4,3.9c0,1.3-2,11.1-2.7,18.3h-4.8c-0.6-7.1-2.8-16.9-2.8-18.3\r\n\tC27.5,21.6,27.9,20.3,28.9,19.2z M36.2,53.1c-1,1-2.2,1.5-3.6,1.5c-1.4,0-2.6-0.5-3.6-1.5c-1-1-1.5-2.2-1.5-3.6\r\n\tc0-1.4,0.5-2.6,1.5-3.6c1-1,2.2-1.5,3.6-1.5c1.4,0,2.6,0.5,3.6,1.5c1,1,1.5,2.2,1.5,3.6C37.7,51,37.2,52.2,36.2,53.1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/alarm.svg
// module id = mMjV
// module chunks = 123